import * as React from "react";
import SummaryCard from "src/components/shared/Cards/SummaryCard";
import {
  VotesOuterWrapper,
  VotesWrapper,
  VotesTable,
  OpenVotesSummaryButton,
} from "src/components/VotesSummaryTable/VotesSummaryTable.components";
import { useGameContext } from "src/game/useGameContext";
import useIsMobile from "src/hooks/useIsMobile";
import { ReactComponent as Angle } from "src/images/angle.svg";

export interface Props {
  isDeckHidden?: boolean;
}

const VotesSummaryTable: React.FunctionComponent<Props> = ({
  isDeckHidden,
}) => {
  const {
    gameState: { voteReveal },
  } = useGameContext();

  const [isOpen, setOpen] = React.useState(false);
  const isMobile = useIsMobile();

  if (!voteReveal) {
    return null;
  }

  const valueToVoteCountMap = voteReveal.votes.reduce((acc, { value }) => {
    if (acc[value]) {
      acc[value] += 1;
    } else {
      acc[value] = 1;
    }

    return acc;
  }, {} as { [key: string]: number });

  const mostVotedOn = Math.max(...Object.values(valueToVoteCountMap));

  return (
    <VotesOuterWrapper isDeckHidden={isDeckHidden} isOpen={isOpen}>
      <VotesWrapper>
        {isMobile && (
          <OpenVotesSummaryButton onClick={() => setOpen(!isOpen)}>
            <Angle />
          </OpenVotesSummaryButton>
        )}
        <h3>Votes</h3>
        <VotesTable>
          {Object.entries(valueToVoteCountMap).map(([label, value]) => (
            <SummaryCard
              key={label}
              numOfVotes={value}
              value={label}
              totalNumOfVotes={voteReveal.votes.length}
              isGreatest={value === mostVotedOn}
            />
          ))}
        </VotesTable>
      </VotesWrapper>
    </VotesOuterWrapper>
  );
};

export default VotesSummaryTable;
